import * as actions from './actions'
import Fuse from 'fuse.js'
import { DEFAULT_TAKE } from '../reports/reducers'
import { DEFAUL_DEVICES_TAKE } from '../devices/constants'

const initState = {
    isLocationsSidebarLoading: false,
    locations: null,
    location: null,
    newLocationId: null,
    sharedUsers: null,
    locationDevices: null,
    devicesSkip: 0,
    isLoadingMoreDevices: null,
    locationNetworkDevices: null,
    locationReports: null,
    isLoadingMoreReports: null,
    reportsSkip: 0,
    locationStatisticsReports: null,
    sharedUsersWithEntity: null,
    availableDevices: null,
    availableNetworkDevices: null,
    locationsFused: null,
    pickerLocationsList: null,
    floorPlan: null,
    floorPlanDevices: null,
    isAddDevicesToFloorPlanMode: false,
    availableDevicesToFloorPlans: null,
    escalationLevels: [],
    flashingDeviceId: null
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.START_LOCATIONS_SIDEBAR_LOADING:
            return {
                ...state,
                ...{
                    isLocationsSidebarLoading: true
                }
            }
        case actions.STOP_LOCATIONS_SIDEBAR_LOADING:
            return {
                ...state,
                ...{
                    isLocationsSidebarLoading: false
                }
            }
        case actions.LOCATIONS_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    locations: action.locations,
                    locationsFused: new Fuse(action.locations || [], {
                        threshold: 0.3,
                        keys: ['name']
                    })
                }
            }
        case actions.SET_LOCATIONS:
            return {
                ...state,
                ...{
                    locations: action.locations
                }
            }
        case actions.SET_PICKER_LOCATIONS_LIST:
            return {
                ...state,
                ...{
                    pickerLocationsList: action.locations
                }
            }
        case actions.LOCATION_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    location: action.location
                }
            }
        case actions.LOCATION_CREATE_SUCCESS:
            return {
                ...state,
                ...{
                    newLocationId: action.newLocationId
                }
            }
        case actions.SHARED_USERS_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    sharedUsers: action.sharedUsers
                }
            }
        case actions.LOCATION_DEVICES_REQUEST:
            return {
                ...state,
                ...{
                    devicesSkip: 0
                }
            }
        case actions.LOCATION_DEVICES_SUCCESS:
            return {
                ...state,
                ...{
                    locationDevices: action.locationDevices,
                    devicesSkip: action.locationDevices?.length
                        ? state.devicesSkip + DEFAUL_DEVICES_TAKE
                        : state.devicesSkip
                }
            }
        case actions.FETCH_MORE_LOCATION_DEVICES:
            return {
                ...state,
                isLoadingMoreDevices: true
            }
        case actions.FETCH_MORE_LOCATION_DEVICES_SUCCESS:
            return {
                ...state,
                isLoadingMoreDevices: false,
                locationDevices: action.locationDevices.length
                    ? [...state.locationDevices, ...action.locationDevices]
                    : [...state.locationDevices],
                devicesSkip: action.locationDevices?.length
                    ? state.devicesSkip + DEFAUL_DEVICES_TAKE
                    : state.devicesSkip
            }
        case actions.LOCATION_NETWORK_DEVICES_SUCCESS:
            return {
                ...state,
                ...{
                    locationNetworkDevices: action.locationNetworkDevices
                }
            }
        case actions.LOCATION_MORE_REPORTS_REQUEST:
            return {
                ...state,
                ...{
                    isLoadingMoreReports: true
                }
            }
        case actions.LOCATION_REPORTS_SUCCESS:
            return {
                ...state,
                ...{
                    locationReports: action.locationReports,
                    reportsSkip: action.locationReports?.length
                        ? state.reportsSkip + DEFAULT_TAKE
                        : state.reportsSkip
                }
            }
        case actions.LOCATION_MORE_REPORTS_SUCCESS:
            return {
                ...state,
                ...{
                    isLoadingMoreReports: false,
                    locationReports: action.locationReports.length
                        ? [...state.locationReports, ...action.locationReports]
                        : [...state.locationReports],
                    reportsSkip: action.locationReports.length
                        ? state.reportsSkip + DEFAULT_TAKE
                        : state.reportsSkip
                }
            }
        case actions.LOCATION_STATISTICS_REPORTS_SUCCESS:
            return {
                ...state,
                ...{
                    locationStatisticsReports: action.locationStatisticsReports
                }
            }
        case actions.LOCATION_ASSIGNED_USERS_SUCCESS:
            return {
                ...state,
                ...{
                    sharedUsersWithEntity: action.sharedUsersWithEntity
                }
            }
        case actions.AVAILABLE_DEVICES_SUCCESS:
            return {
                ...state,
                ...{
                    availableDevices: action.availableDevices
                }
            }
        case actions.AVAILABLE_NETWORK_DEVICES_SUCCESS:
            return {
                ...state,
                ...{
                    availableNetworkDevices: action.availableNetworkDevices
                }
            }
        case actions.MOVE_TO_LOCATION_DEVICES: {
            const deviceIndex = state.availableDevices.findIndex(
                d => d.id === action.deviceId
            )
            const device = {
                ...state.availableDevices[deviceIndex],
                is_fresh: true
            }
            const newLocationDevices = [...state.locationDevices, device]
            return {
                ...state,
                ...{
                    locationDevices: newLocationDevices
                }
            }
        }
        case actions.MOVE_TO_LOCATION_NETWORK_DEVICES: {
            const deviceIndex = state.availableNetworkDevices.findIndex(
                d => d.id === action.deviceId
            )
            const device = {
                ...state.availableNetworkDevices[deviceIndex],
                is_fresh: true
            }
            const newLocationDevices = [...state.locationNetworkDevices, device]
            return {
                ...state,
                ...{
                    locationNetworkDevices: newLocationDevices
                }
            }
        }
        case actions.MOVE_FROM_LOCATION_DEVICES: {
            const deviceIndex = state.locationDevices.findIndex(
                d => d.id === action.deviceId
            )
            const device = { ...state.locationDevices[deviceIndex] }
            delete device.is_fresh
            const newAvailableDevices = [...state.availableDevices, device]
            const newLocationDevices = state.locationDevices.filter(
                d => d.id !== action.deviceId
            )
            return {
                ...state,
                ...{
                    availableDevices: newAvailableDevices,
                    locationDevices: newLocationDevices
                }
            }
        }
        case actions.MOVE_FROM_LOCATION_NETWORK_DEVICES: {
            const deviceIndex = state.locationNetworkDevices.findIndex(
                d => d.id === action.deviceId
            )
            const device = { ...state.locationNetworkDevices[deviceIndex] }
            delete device.is_fresh
            const newAvailableDevices = [
                ...state.availableNetworkDevices,
                device
            ]
            const newLocationDevices = state.locationNetworkDevices.filter(
                d => d.id !== action.deviceId
            )
            return {
                ...state,
                ...{
                    availableNetworkDevices: newAvailableDevices,
                    locationNetworkDevices: newLocationDevices
                }
            }
        }
        case actions.FLOOR_PLAN_SUCCESS: {
            return {
                ...state,
                ...{
                    floorPlan: action.floorPlan
                }
            }
        }
        case actions.FLOOR_PLAN_DEVICES_SUCCESS: {
            let devices = action.floorPlanDevices
            if (action.floorPlanNetworkDevices) {
                devices = [
                    ...action.floorPlanDevices,
                    ...action.floorPlanNetworkDevices
                ]
            }
            return {
                ...state,
                ...{
                    floorPlanDevices: devices
                }
            }
        }
        case actions.SET_IS_ADD_DEVICES_TO_FLOOR_PLAN_MODE: {
            return {
                ...state,
                ...{
                    isAddDevicesToFloorPlanMode:
                        action.isAddDevicesToFloorPlanMode
                }
            }
        }
        case actions.AVAILABLE_DEVICES_TO_FLOOR_PLANS_SUCCESS: {
            const floorPlanDevicesMap = state.floorPlanDevices?.reduce(
                (acc, d) => ({ ...acc, [d.id]: d }),
                {}
            )
            const devicesFiltered = action.availableDevicesToFloorPlans.filter(
                d => !floorPlanDevicesMap.hasOwnProperty(d.id)
            )
            return {
                ...state,
                ...{
                    availableDevicesToFloorPlans: devicesFiltered
                }
            }
        }
        case actions.SET_ESCALATION_LEVELS: {
            return {
                ...state,
                escalationLevels: action.escalationLevels
            }
        }
        case actions.TRIGGER_FLASHING_EFFECT:
            return {
                ...state,
                flashingDeviceId: action.deviceId
            }
        case actions.RESET_FLASHING_EFFECT:
            return {
                ...state,
                flashingDeviceId: null
            }
        //TODO NETWORK DEVICES FOR FLOOR PLANS @Vlad still actual todo?
        default:
            return state
    }
}
